module.exports = __webpack_public_path__ + "img/2.c9d216d1.png";